<template>
  <div class="project-modal user-select-modal">
    <div class="project-modal__background"
         @click="close()"></div>
    <div class="project-modal__inner">
      <div class="project-modal__close"
           @click="close()">X
      </div>
      <h2>Find user</h2>
      <div class="search"
           :class="{'search--active': users.length > 0}">
        <input type="text"
               name="query"
               ref="searchInput"
               placeholder="Search by name or email."
               @keyup.enter="searchUsers()"
               v-model="query"/>
        <button type="button"
                class="button brand-background brand-hover-background-darker"
                @click="searchUsers()">
          <span class="icon icon-search"></span>
          <span>Search</span>
        </button>
      </div>
      <ul class="users"
          v-show="users.length > 0">
        <li v-for="user in users"
            :key="user.id"
            @click="saveChanges(user)">
          {{ user.first_name }} {{ user.last_name }}
          <SvgRight/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SvgRight from '@/components/svgs/SvgRight.vue'

/**
 * Ability to select a user for a filter or other purposes.
 */
export default {
  name: 'UserSelectModal',
  components: {
    SvgRight
  },
  data () {
    return {
      users: [],
      query: null
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapStores(useStore),
  },
  watch: {
    visible (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus()
          }
        })
      }
    }
  },
  methods: {
    /**
     * Reset the modal state.
     */
    reset () {
      this.users = []
      this.query = ''
    },
    /**
     * Save changes to the user.
     */
    saveChanges (user) {
      this.$emit('userSelected', user)
      this.reset()
    },
    /**
     * Close modal.
     */
    close () {
      this.$emit('close')
      this.reset()
    },
    /**
     * Search for users.
     */
    async searchUsers () {
      const query = this.query.trim()
      if (!query) {
        this.users = []
        return
      }

      this.store.setLoading()

      try {
        this.users = await useFetchDrupal('/projects/user/list', {
          method: 'GET',
          params: {
            query: query,
          },
        })
      } catch (e) {
        console.error('Error fetching users:', e)
        this.store.setMessage({
          type: 'error',
          text: 'Unable to search, please try again.'
        })
      }

      this.store.clearLoading()
    },
  }
}
</script>

<style scoped lang="scss">
.users {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #eee;

  li {
    padding: 1rem;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: space-between;

    :deep(svg) {
      width: 1.5rem;
      height: 1.5rem;
    }

    &:hover {
      background-color: #f0f0f0;
    }
  }
}

.search {
  display: flex;
  align-items: center;
  padding-top: 1rem;

  &.search--active {
    box-shadow: 0 3px 3px -3px rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid #eee;
    padding-bottom: 1rem;
  }

  input {
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 0.25rem 0 0 0.25rem;
    height: 2.25rem;
  }

  button {
    padding: 0.5rem 1rem;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 0 0.25rem 0.25rem 0;
    height: 2.25rem;

    &:hover {
      background-color: #0056b3;
    }
  }
}
</style>
